import React, { FC, useRef } from 'react';
import { BsFillPatchCheckFill } from 'react-icons/all';
import { beExperience } from 'configs/experienceData';
import { useCountNumber, useOnScreen } from 'shared/helpers';

export const ClBackendExp: FC = () => {
  const elementOnScreen = useRef<HTMLDivElement>(null);
  const isOnScreen = useOnScreen(elementOnScreen);
  return (
    <>
      <h6 className="title">Backend Development</h6>
      <div ref={elementOnScreen} className="exp-item-container">
        {beExperience.map((val, index) => {
          // eslint-disable-next-line react-hooks/rules-of-hooks
          const percentCount = useCountNumber(val.percent, 30, isOnScreen);
          return (
            <div key={index} className="exp-item">
              <article className="exp-detail d-flex">
                <BsFillPatchCheckFill />
                <div className="detail-container">
                  <p className="exp-label">{val.label}</p>
                  <div className="line-container">
                    <div className="percent-desc">
                      <p className="percent">{percentCount}%</p>
                    </div>
                    <div className="line-parent">
                      <div
                        className="percent"
                        style={{
                          width: `${percentCount}%`,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </article>
            </div>
          );
        })}
      </div>
    </>
  );
};
